export const MAP_API_KEY = 'AIzaSyCmqJCOj29SsVcp7YPSXI_cyxADWEA8Z_M';
